export default __webpack_public_path__ + "static/media/featSport.105c9c4f.png";